import { Routes, Route, Outlet, } from "react-router-dom";

import AuthNavbar from '@/components/Navbars/AuthNavbar';
import FooterSmall from '@/components/Footers/FooterSmall';

import bg2 from '@/assets/img/register_bg_2.png'

/* component for authentication - login , signup, etc */

export default function Auth() {
  return (
    <>
      <AuthNavbar transparent />
      <main>
        <section className="relative w-full h-full py-40 min-h-screen">
          <div
            className="absolute top-0 w-full h-full bg-slate-800 bg-no-repeat bg-full"
            style={{ backgroundImage: `url(${bg2})` }}>
          </div>
          <Outlet />
          <FooterSmall absolute />
        </section>
      </main>
    </>
  );
}
